import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    listPrescriptions: -1,
    creating: -1,
    details: -1,
    prescriptionOrder: -1,
    loadDoctor: -1,
    loadTemplates: -1,
    createTemplate: -1,
    updateTemplate: -1,
    deleteTemplate: -1,
    prescriptionConfig: -1,
    medicineParse: -1,
    pendingPrescription: -1,
    voidPrescription: -1,
    searchProducts: -1,
    clinicalTerm: -1,
    otterSgMedicine: -1,
    documentTemplates: -1,
    searchLifepackProducts: -1,
    lifepackMedicine: -1,
  },
  data: {},
  pendingPrescription: null,
  prescriptionOrder: null,
  clinicalTerm: null,
  otterSgMedicine: null,
  lifepackMedicine: null,
  doctorInfo: {},
  templates: [],
  prescriptions: [],
  searchProducts: [],
  searchLifepackProducts: [],
  documentTemplates: [],
  error: null,
  deliveryFee: {
    amount: 0,
    currency: 'SGD',
  },
  prescriptionConfig: {},
  medicineParse: {},
  meta: {},
};

export default function reducer(state = initialState, action) {
  const { type, payload, error, meta } = action;
  const isLoadMore = meta?.isLoadMore ?? false;
  switch (type) {
    // create prescription
    case ACTION_TYPES.PRESCRIPTION_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 1,
        },
        data: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_CREATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          creating: 2,
        },
        error: error?.data,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_REQUESTED:
      return {
        ...state,
        data: {},
        status: {
          ...state.status,
          details: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          details: 1,
        },
        data: payload.data,
        error: {
          ...state.error,
          details: null,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          details: 2,
        },
        error: {
          details: error,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_ORDER_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          prescriptionOrder: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_ORDER_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          prescriptionOrder: 1,
        },
        prescriptionOrder: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_ORDER_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          prescriptionOrder: 2,
        },
        error: {
          prescriptionOrder: error,
        },
      };

    case ACTION_TYPES.PRESCRIPTION_DOCTOR_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDoctor: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_DOCTOR_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDoctor: 1,
        },
        doctorInfo: payload,
      };
    case ACTION_TYPES.PRESCRIPTION_DOCTOR_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadDoctor: 2,
        },
        error: error?.data,
      };

    case ACTION_TYPES.PRESCRIPTION_LIST_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          listPrescriptions: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_LIST_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          listPrescriptions: 1,
        },
        prescriptions: isLoadMore ? [...state.prescriptions, ...payload.data] : payload.data,
        meta: payload.meta,
      };
    case ACTION_TYPES.PRESCRIPTION_LIST_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          listPrescriptions: 2,
        },
      };

    case ACTION_TYPES.PRESCRIPTION_TEMPLATES_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTemplates: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATES_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTemplates: 1,
        },
        templates: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATES_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadTemplates: 2,
        },
        error,
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_CREATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          createTemplate: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_CREATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          createTemplate: 1,
        },
        templates: [...state.templates, payload.data],
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_CREATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          createTemplate: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_UPDATE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          createTemplate: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_UPDATE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          createTemplate: 1,
        },
        templates: state.templates.map(i => (i.id === payload.data.id ? payload.data : i)),
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_UPDATE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          createTemplate: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_DELETE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteTemplate: 0,
        },
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_DELETE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteTemplate: 1,
        },
        templates: state.templates.filter(i => i.id !== meta.id),
      };
    case ACTION_TYPES.PRESCRIPTION_TEMPLATE_DELETE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          deleteTemplate: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_CONFIG_GET_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          prescriptionConfig: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_CONFIG_GET_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          prescriptionConfig: 1,
        },
        prescriptionConfig: payload.data,
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_CONFIG_GET_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          prescriptionConfig: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_CONFIG_PARSE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          medicineParse: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_CONFIG_PARSE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          medicineParse: 1,
        },
        error: null,
        medicineParse: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_CONFIG_PARSE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          medicineParse: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_GET_PENDING_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          pendingPrescription: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_PENDING_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          pendingPrescription: 1,
        },
        error: null,
        pendingPrescription: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_PENDING_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          pendingPrescription: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_VOID_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          voidPrescription: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_VOID_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          voidPrescription: 1,
        },
        error: null,
        voidPrescription: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_VOID_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          voidPrescription: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_SEARCH_PRODUCT_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          searchProducts: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_SEARCH_PRODUCT_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          searchProducts: 1,
        },
        error: null,
        searchProducts: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_SEARCH_PRODUCT_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          searchProducts: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_GET_CLINICAL_TERM_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          clinicalTerm: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_CLINICAL_TERM_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          clinicalTerm: 1,
        },
        error: null,
        clinicalTerm: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_CLINICAL_TERM_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          clinicalTerm: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_GET_OTTER_MEDICINE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          otterSgMedicine: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_OTTER_MEDICINE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          otterSgMedicine: 1,
        },
        error: null,
        otterSgMedicine: payload.data,
      };

    case ACTION_TYPES.PRESCRIPTION_GET_OTTER_MEDICINE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          otterSgMedicine: 2,
        },
        error,
      };

    // getLifepackMedicine
    case ACTION_TYPES.PRESCRIPTION_GET_LIFEPACK_MEDICINE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          lifepackMedicine: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_LIFEPACK_MEDICINE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          lifepackMedicine: 1,
        },
        error: null,
        lifepackMedicine: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_LIFEPACK_MEDICINE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          lifepackMedicine: 2,
        },
        error,
      };

    // getDocumentTemplates
    case ACTION_TYPES.PRESCRIPTION_GET_DOCUMENT_TEMPLATES_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          documentTemplates: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_GET_DOCUMENT_TEMPLATES_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          documentTemplates: 1,
        },
        error: null,
        documentTemplates: payload.data || [],
      };
    case ACTION_TYPES.PRESCRIPTION_GET_DOCUMENT_TEMPLATES_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          documentTemplates: 2,
        },
        error,
      };

    // searchLifepackProducts
    case ACTION_TYPES.PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          searchLifepackProducts: 0,
        },
        error: null,
      };
    case ACTION_TYPES.PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          searchLifepackProducts: 1,
        },
        error: null,
        searchLifepackProducts: payload.data,
      };
    case ACTION_TYPES.PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          searchLifepackProducts: 2,
        },
        error,
      };

    case ACTION_TYPES.PRESCRIPTION_RESET:
      return initialState;

    default:
      return state;
  }
}
